/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Popover } from '@material-ui/core';
import { setDrugInterestResposne } from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

const ActionButtonRenderer = (props) => {
  const dispatch = useDispatch();

  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const handleClose = () => {
    setAnchor(null);
  };
  const id = open ? 'simple-popover' : undefined;

  const { calculatedInterestPayload } = useSelector(
    (state) => state?.sharedState?.CalculatedInterestReducer
  );

  const handleMenudItemClicked = async () => {
    const payload = {
      drugInterestCalculatedPK: {
        drugSeqNum: props?.data?.drugQtrDetailsId?.drugSeqNum,
        drugInterestQtr: props?.data?.qtr,
      },

      rebateProgramCd: calculatedInterestPayload?.rebateProgramCd,
    };
    const response = await axios.post(
      `${serviceEndPoint.VIEW_CALCULATED_INTEREST_DETAILS}`,
      payload
    );
    const resData = [];
    const gridData = response.data;
    gridData.forEach((item) => {
      const temp = {
        ...item,
        drugInterestQtr: item?.drugInterestCalculatedPK.drugInterestQtr,
        interestCalculationBeginDt:
          item?.drugInterestCalculatedPK.interestCalculationBeginDt,
        descr: item?.drugInterestCalculatedPK.descr,
      };
      resData.push(temp);
    });
    // setQtrGridData(resData);
    dispatch(setDrugInterestResposne(resData));
    // const elem = document.getElementById('secondgrid');
    // if (elem) {
    //   setTimeout(() => {
    //     elem.scrollIntoView();
    //   }, 1000);
    // }
    handleClose();
  };

  return (
    <div className="tdCell icon-btn-group" data-testid="action-column">
      <div
        style={{ height: 'max-content', cursor: 'pointer' }}
        onClick={(e) => {
          setAnchor(e.currentTarget);
        }}
      >
        <SVGComponent iconName="Icon-export1" />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div className="d-flex flex-column py-2">
          <span
            className="dropdown-item"
            style={{ cursor: 'pointer' }}
            onClick={handleMenudItemClicked}
          >
            Display Interest Details
          </span>
        </div>
      </Popover>
    </div>
  );
};

export default ActionButtonRenderer;
